export function formatControlUnitDisplayList(formData = {}) {
  const controlUnits = Array.isArray(formData.control_units) ? formData.control_units : [];
  const multiDisplay = controlUnits
    .map((item) => item?.tagValue || item?.tag_value || item?.modelName || item?.brandName || item?.typeName)
    .filter(Boolean);

  if (multiDisplay.length > 0) {
    return multiDisplay;
  }

  const singleDisplay = formData.control_unit?.tag_value;
  return singleDisplay ? [singleDisplay] : [];
}
